import QRLogin from './QRLogin';

export default QRLogin;
